import React from 'react';

import ArchivedTripsContainer from './archived-trips-container';

const ProvidedArchivedTripsContainer = () => (
  <ArchivedTripsContainer />
);

export default ProvidedArchivedTripsContainer;
